import React from "react";

interface Props {
    searchTerm: string;
    onSearchChange: (val: string) => void;
    activeFilter: string;
    onFilterChange: (val: string) => void;
}

const ValidacionFilterToolbar: React.FC<Props> = ({ searchTerm, onSearchChange, activeFilter, onFilterChange }) => {
    const filters = [
        { id: "todos", label: "Todos" },
        { id: "pending", label: "Pendientes" },
        { id: "review", label: "En revisión" },
        { id: "approved", label: "Aprobados" },
        { id: "rejected", label: "Rechazados" }
    ];

    return (
        <div className="py-3 px-4 md:px-[28px] border-b border-gray-200 bg-white flex flex-col md:flex-row gap-3 md:items-center shrink-0">
            <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 py-[7px] w-full md:w-auto md:min-w-[240px] focus-within:border-[#4f6df5] focus-within:ring-1 focus-within:ring-[#4f6df5]/20 transition-all shrink-0">
                <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                    type="text"
                    className="bg-transparent border-none outline-none text-[13px] text-gray-900 w-full placeholder:text-gray-400"
                    placeholder="Buscar usuario..."
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>

            <div className="flex gap-2 overflow-x-auto w-full md:w-auto pb-1 md:pb-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                {filters.map((f) => (
                    <button
                        key={f.id}
                        className={`text-[11px] font-semibold px-3 py-1.5 rounded-full border transition-all duration-200 whitespace-nowrap shrink-0 ${
                            activeFilter === f.id
                                ? "bg-[#4f6df5] border-[#4f6df5] text-white shadow-sm"
                                : "bg-white border-gray-200 text-gray-600 hover:text-gray-900 hover:border-gray-300 hover:bg-gray-50"
                        }`}
                        onClick={() => onFilterChange(f.id)}
                    >
                        {f.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ValidacionFilterToolbar;